






































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import {
  both, includes, filter, sortBy, sortWith, prop, descend, ascend,
} from 'ramda'
import dayjs from 'dayjs'
// import { vueVimeoPlayer } from 'vue-vimeo-player'
import {
  getModule,
} from 'vuex-module-decorators'
import { DisplaySlideType, DisplayBoardType, SlideDetailsType } from '../../types'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'

// Filter Functions

@Component({
  components: {
  },
})

export default class AllSlides<T extends Vue> extends Mixins(MainMixin) {
  @Prop() data!: DisplaySlideType[]

  @Prop() landscape!: boolean

  @Prop() showActive!: boolean

  @Prop() type!: string

  @Emit()
  makeactive (slide: DisplaySlideType) {
    console.log('asdf making active: ', slide)
    return slide
  }

  @Emit()
  display (x: string, y: string) {
    return [x, y]
  }

  detailsMap = {
    scheduleStartDate: false,
    scheduleEndDate: false,
  }

  get filteredSlides () {
    return this.data.filter(slide => (slide.landscape === this.landscape && slide.type === this.type.toLowerCase() && slide.active === this.showActive))
  }
}
